import { createSlice } from "@reduxjs/toolkit";
import { fetchCashBankAccountLedger, fetchCashBankAccounts } from "./CashBankAccountLedgerThunk";

const initialState = {
  list: [],
  accounts: [],
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const cashBankAccountLedgerSlice = createSlice({
  name: "cashBankAccountLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCashBankAccountLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCashBankAccountLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCashBankAccountLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchCashBankAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload;
      });
  },
});

export const { setFilters } = cashBankAccountLedgerSlice.actions;
export default cashBankAccountLedgerSlice.reducer;
